import _ from 'lodash';

export function formatSankeyMetricSeries(metricSeries, metrics) {
    const data = metricSeries.filter(x => x[metrics[2]]);
    const sources = data.map(x => ({
        id: `s${x[metrics[0]]}`,
        name: x[metrics[0]]
    }));
    const targets = data.map(x => ({
        id: `t${x[metrics[1]]}`,
        name: x[metrics[1]]
    }));
    const nodes = _.uniqBy(sources.concat(targets), 'id');
    const nodeIds = nodes.map(x => x.id);

    const links = data.map(x => ({
        source: nodeIds.indexOf(`s${x[metrics[0]]}`),
        target: nodeIds.indexOf(`t${x[metrics[1]]}`),
        value: x[metrics[2]]
    }));

    return { nodes, links };
}
